var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"d-inline mr-1",attrs:{"width":"15","src":_vm.icon}})
}
var staticRenderFns = []

export { render, staticRenderFns }